// import { Label } from '../Label';
import { CmToFtAndInch } from "../../lengthConvertor";
import { LabelDim } from "./LabelDim";
// import { Label } from '../Label';

declare let THREE: any;

export class SizeDim extends LabelDim {
  private static up = new THREE.Vector3(0, 1, 0);
  private static angle = THREE.Math.degToRad(90);

  constructor() {
    super({ width: 30, height: 20 }, { fontSize: 18 });
  }

  update(startPoint, endPoint) {
    const size = startPoint.distanceTo(endPoint);
    super.updateText(CmToFtAndInch(size));

    const direction = endPoint
      .clone()
      .sub(startPoint)
      .normalize();

    const horizontalOffset = direction.clone().multiplyScalar(size / 2);

    // const verticalOffset = direction
    //   .clone()
    //   .applyAxisAngle(SizeDim.up, SizeDim.angle)
    //   .multiplyScalar(this.scale.x / 4);

    this.position.copy(horizontalOffset).add(new THREE.Vector3(0, 100, 0));

    // rotate the sizeDim, so it'll be
    // aligned with the arrow
    const rotation = Math.atan2(
      endPoint.x - startPoint.x,
      endPoint.z - startPoint.z
    );
    this.rotation.z =
      rotation > 0 ? rotation - Math.PI / 2 : rotation + Math.PI / 2;
  }

  updateText(text: string) {
    super.updateText(text);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Dimensions/SizeDim.ts